<template>
  <div class="modal fade" id="modal_nfse_settings" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Configurações de NFSe</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab-settings">
                Configurações
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-authentication">
                Autenticação
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-certificate">
                Certificado Digital
              </button>
            </li>
          </ul>

          <div class="tab-content pt-4">
            <!-- Tab Configurações -->
            <div class="tab-pane fade show active" id="tab-settings">
              <form @submit.prevent="saveSettings">
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <div class="alert alert-light border">
                      <div class="row">
                        <div class="col-md-6">
                          <small class="text-muted d-block mb-1">CNPJ/CPF do Emissor</small>
                          <strong>{{ formatDocument(place.place_document) || '-' }}</strong>
                        </div>
                        <div class="col-md-6">
                          <small class="text-muted d-block mb-1">Razão Social</small>
                          <strong>{{ place.place_name || '-' }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label required">Ambiente</label>
                    <select class="form-select" v-model="settings.nfse_environment" required>
                      <option value="2">Homologação</option>
                      <option value="1">Produção</option>
                    </select>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label required">Inscrição Municipal</label>
                    <input type="text" class="form-control" v-model="settings.nfse_municipal_registration" required>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label required">Código Tributação Nacional</label>
                    <input type="text" class="form-control" v-model="settings.nfse_tax_code_national" required>
                    <small class="text-muted">Ex: 010501</small>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label">Código Tributação Municipal</label>
                    <input type="text" class="form-control" v-model="settings.nfse_tax_code_municipal">
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label">CNAE</label>
                    <input type="text" class="form-control" v-model="settings.nfse_cnae">
                  </div>

                  <div class="col-md-12 mb-3">
                    <label class="form-label required">Descrição Padrão do Serviço</label>
                    <textarea class="form-control" v-model="settings.nfse_service_description" rows="2" required></textarea>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label required">Simples Nacional</label>
                    <select class="form-select" v-model="settings.nfse_simples_nacional" required>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                      <option value="3">MEI</option>
                    </select>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label required">Regime Especial</label>
                    <select class="form-select" v-model="settings.nfse_special_regime" required>
                      <option value="0">Nenhum</option>
                      <option value="1">Microempresa Municipal</option>
                      <option value="2">Estimativa</option>
                      <option value="3">Sociedade de Profissionais</option>
                      <option value="4">Cooperativa</option>
                      <option value="5">MEI - Simples Nacional</option>
                      <option value="6">ME ou EPP - Simples Nacional</option>
                    </select>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label required">Incentivador Cultural</label>
                    <select class="form-select" v-model="settings.nfse_cultural_promoter" required>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                    </select>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label required">Alíquota ISS (%)</label>
                    <input type="number" step="0.01" class="form-control" 
                           v-model="settings.nfse_iss_aliquot" required min="0" max="100">
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label required">Série do RPS</label>
                    <input type="text" class="form-control" v-model="settings.nfse_rps_serie" required>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label class="form-label">Próximo Número RPS</label>
                    <input type="number" class="form-control" v-model="settings.nfse_rps_number" min="1">
                  </div>

                  <div class="col-md-3 mb-3">
                    <div class="form-check mt-4">
                      <input class="form-check-input" type="checkbox" 
                             v-model="settings.nfse_iss_retained" id="defaultIssRetained">
                      <label class="form-check-label" for="defaultIssRetained">ISS Retido por Padrão</label>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" 
                             v-model="settings.nfse_dfe_enabled" id="nfseDfeEnabled">
                      <label class="form-check-label" for="nfseDfeEnabled">
                        Habilitar busca automática de NFSe
                      </label>
                      <small class="form-text text-muted d-block">
                        Quando habilitado, o sistema buscará automaticamente as NFSe emitidas para o seu CNPJ. <br>
                        (O certificado digital é obrigatório para essa funcionalidade.)
                      </small>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    <label class="form-label">Informações Complementares Padrão</label>
                    <textarea class="form-control" v-model="settings.nfse_additional_info" rows="2"></textarea>
                  </div>
                </div>

                <div class="text-end">
                  <button type="submit" class="btn btn-primary" :disabled="savingSettings">
                    {{ savingSettings ? 'Salvando...' : 'Salvar Configurações' }}
                  </button>
                </div>
              </form>
            </div>

            <!-- Tab Autenticação -->
            <div class="tab-pane fade" id="tab-authentication">
              <form @submit.prevent="saveSettings">
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <div class="alert alert-info">
                      <i class="bi bi-info-circle me-2"></i>
                      <strong>Autenticação de Prestadora</strong><br>
                      <small>Algumas prestadoras exigem login e senha para autenticação. Preencha apenas se sua prestadora exigir.</small>
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label">Login</label>
                    <input type="text" class="form-control" v-model="settings.nfse_login"
                           placeholder="Login para prestadoras que exigem autenticação">
                    <small class="text-muted">Obrigatório para algumas prestadoras (ex: SigissWeb)</small>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="form-label">Senha</label>
                    <input type="password" class="form-control" v-model="settings.nfse_password"
                           placeholder="Senha para prestadoras que exigem autenticação">
                    <small class="text-muted">Obrigatório para algumas prestadoras (ex: SigissWeb)</small>
                  </div>
                </div>

                <div class="text-end">
                  <button type="submit" class="btn btn-primary" :disabled="savingSettings">
                    {{ savingSettings ? 'Salvando...' : 'Salvar Configurações' }}
                  </button>
                </div>
              </form>
            </div>

            <!-- Tab Certificado -->
            <div class="tab-pane fade" id="tab-certificate">
              <!-- Certificado Atual -->
              <div v-if="activeCertificate && activeCertificate.id_place_certificate" class="alert alert-info mb-4">
                <div class="d-flex align-items-center">
                  <i class="bi bi-shield-check fs-2 me-3"></i>
                  <div class="flex-grow-1">
                    <strong>{{ activeCertificate.certificate_name }}</strong><br>
                    <small>
                      CNPJ: {{ activeCertificate.certificate_cnpj || 'N/A' }}<br>
                      Validade: {{ formatDate(activeCertificate.certificate_valid_until) }}
                    </small>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <span v-if="activeCertificate.is_expired" class="badge bg-danger">Expirado</span>
                    <span v-else-if="activeCertificate.is_expiring_soon" class="badge bg-warning">
                      Expira em {{ activeCertificate.days_until_expiration }} dias
                    </span>
                    <span v-else class="badge bg-success">Válido</span>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-outline-danger"
                      @click="deleteCertificate"
                      :disabled="deletingCertificate">
                      <i class="bi bi-trash"></i> Excluir
                    </button>
                  </div>
                </div>
              </div>

              <!-- Upload de Certificado -->
              <form @submit.prevent="uploadCertificate">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label class="form-label required">Nome do Certificado</label>
                    <input type="text" class="form-control" v-model="certificate.name" required
                           placeholder="Ex: Certificado A1 - Empresa">
                  </div>

                  <div class="col-md-12 mb-3">
                    <label class="form-label required">Arquivo do Certificado (.pfx ou .p12)</label>
                    <input type="file" class="form-control" @change="onFileChange" 
                           accept=".pfx,.p12" required ref="certFile">
                  </div>

                  <div class="col-md-12 mb-3">
                    <label class="form-label required">Senha do Certificado</label>
                    <input type="password" class="form-control" v-model="certificate.password" required>
                  </div>
                </div>

                <div class="text-end">
                  <button type="submit" class="btn btn-primary" :disabled="uploadingCertificate">
                    {{ uploadingCertificate ? 'Enviando...' : 'Enviar Certificado' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import date from "../../helpers/date";

export default {
  name: "ModalNfseSettings",
  data() {
    return {
      modal: null,
      savingSettings: false,
      uploadingCertificate: false,
      deletingCertificate: false,
      activeCertificate: null,
      settings: this.getEmptySettings(),
      certificate: {
        name: '',
        file: null,
        password: '',
      },
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.modal = new bootstrap.Modal(document.getElementById('modal_nfse_settings'));
  },
  methods: {
    date: date,
    formatDocument(doc) {
      if (!doc) return '-';
      const numbers = doc.replace(/\D/g, '');
      if (numbers.length === 11) {
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (numbers.length === 14) {
        return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return doc;
    },
    getEmptySettings() {
      return {
        nfse_environment: '2',
        nfse_municipal_registration: '',
        nfse_tax_code_national: '',
        nfse_tax_code_municipal: '',
        nfse_service_description: '',
        nfse_cnae: '',
        nfse_simples_nacional: '1',
        nfse_special_regime: '0',
        nfse_cultural_promoter: '2',
        nfse_iss_aliquot: '',
        nfse_iss_retained: false,
        nfse_rps_serie: 'NFSE',
        nfse_rps_number: 1,
        nfse_additional_info: '',
        nfse_dfe_enabled: false,
        nfse_login: '',
        nfse_password: '',
      };
    },
    async open() {
      await Promise.all([
        this.loadSettings(),
        this.loadActiveCertificate(),
      ]);
      this.modal.show();
    },
    async loadSettings() {
      try {
        const response = await http.get(`/places/${this.place.id_place}/nfse/settings`);
        if (response.data) {
          this.settings = { ...this.getEmptySettings(), ...response.data };
        }
      } catch (e) {
        console.error('Erro ao carregar configurações:', e);
      }
    },
    async loadActiveCertificate() {
      try {
        const response = await http.get(`/places/${this.place.id_place}/nfse/certificates/active`);
        this.activeCertificate = response.data && response.data.id_place_certificate ? response.data : null;
      } catch (e) {
        console.error('Erro ao carregar certificado:', e);
        this.activeCertificate = null;
      }
    },
    async saveSettings() {
      this.savingSettings = true;
      try {
        await http.post(`/places/${this.place.id_place}/nfse/settings`, this.settings);
        Alert.toastSuccess('Configurações salvas com sucesso!');
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao salvar configurações.');
      } finally {
        this.savingSettings = false;
      }
    },
    onFileChange(e) {
      this.certificate.file = e.target.files[0];
    },
    async uploadCertificate() {
      if (!this.certificate.file) {
        Alert.toastError('Selecione o arquivo do certificado.');
        return;
      }

      this.uploadingCertificate = true;
      try {
        const formData = new FormData();
        formData.append('certificate_name', this.certificate.name);
        formData.append('certificate_file', this.certificate.file);
        formData.append('certificate_password', this.certificate.password);

        await http.post(`/places/${this.place.id_place}/nfse/certificates`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        Alert.toastSuccess('Certificado enviado com sucesso!');
        this.certificate = { name: '', file: null, password: '' };
        this.$refs.certFile.value = '';
        await this.loadActiveCertificate();
      } catch (e) {
        Alert.toastError(e.response?.data?.error || 'Erro ao enviar certificado.');
      } finally {
        this.uploadingCertificate = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      return this.date(dateStr).format('DD/MM/YYYY');
    },
    async deleteCertificate() {
      if (!this.activeCertificate) return;

      const result = await Swal.fire({
        title: 'Excluir Certificado?',
        text: `Tem certeza que deseja excluir o certificado "${this.activeCertificate.certificate_name}"? Esta ação não pode ser desfeita.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      this.deletingCertificate = true;
      try {
        await http.delete(`/places/${this.place.id_place}/nfse/certificates/${this.activeCertificate.id_place_certificate}`);
        Alert.toastSuccess('Certificado excluído com sucesso!');
        this.activeCertificate = null;
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao excluir certificado.');
      } finally {
        this.deletingCertificate = false;
      }
    },
  },
};
</script>



